<div class="flex-horizontal width-100pc">
  <oui-textfield
    label=" Montant du versement"
    type="number"
    class="flex-1"
    iconSuffix="euro"
    [control]="control"
    [allowWheelValueChange]="false"
    [showNumberStepper]="false"></oui-textfield>
  <div class="flex-1"></div>
</div>
